define((require) => {
    "use strict";

    var Permissions   = require("shared/security/Permissions"),
        Preconditions = require("shared/util/Preconditions");

    /**
     * Helper class for utility methods for Manage Users views.
     */
    return {
        /**
         * Map role list needed for adding additional text.
         * Note: SiteManager is filtered out of the list on purpose as it should only be assigned via Zelp.
         * @param {Array} roles, List of roles to be mapped with additional text.
         * @returns {Array}, A new List of roles with additional text displayed on the Role dropdown.
         */
        mapRoles: function(roles) {
            return roles
                .filter((filterRole) => (filterRole !== Permissions.Roles.SITEMANAGER.name))
                .map((role) => {
                    var label = this.createRoleLabel(role);
                    return {role: Permissions.Roles.of(role), roleLabel: label};
                });
        },

        /**
         * Creates a more meaningful role label.
         * @param {string} role, the user role from which a label will be created.
         * @returns {string} label, the role label displayed in the Role dropdown.
         * @throws {Error} If the role cannot be recognized.
         */
        createRoleLabel: function(role) { // TODO: this should use the Role enum, not the string name!
            switch (role) {
                case "Manager":
                    return role + " (full access)";

                case "Creator":
                    return role + " (create/edit)";

                case "Spectator":
                    return role + " (share/comment)";

                case "Publisher":
                    return role + " (create/edit/publish)";

                case "SiteManager":
                    return role + " (full site access)";

                default:
                    // TODO Candidate for refactoring during MOS-2934.
                    Preconditions.warn("DefaultSwitchWarn - Role '" + role + "' not recognized.");
                    break;
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/manageAccount/ManageUsersHelper.js